export default {
  feedback: {
    usage_threshold: 'Montant minimum du panier pour ce code promo (hors frais de livraison)',
    promo_code_added: 'Code promo appliqué',
    promo_code_removed: 'Code promo {{code}} supprimé',
  },
};
